import SvgPCMenuArrow from "./SvgPCMenuArrow";
import { Col, Row } from "@/utils/bootstrap";
interface Props {
  title: {
    Svg?: any;
    url?: string;
    text?: string;
    other?: any;
  };
  dropdown?: boolean;
  notMain?: boolean;
  rotate?: boolean;
}
const PCMenuItemTitle: React.FC<Props> = ({
  title,
  dropdown = false,
  notMain = false,
  rotate = false,
}) => {
  const { Svg, url, text, other } = title ?? {};
  return (
    <Row className="m-0 w-100 flex-nowrap align-items-center">
      <Col className="p-0 col-auto d-flex flex-nowrap align-items-center">
        {Svg && <div style={{ marginInlineEnd: 8 }}>{Svg}</div>}
        {url && (
          <div style={{ marginInlineStart: -16, marginInlineEnd: 12 }}>
            {/* eslint-disable-next-line  @next/next/no-img-element*/}
            <img alt="url" src={url} width={24} height={24} />
          </div>
        )}
        <div className="text-nowrap">{text}</div>
      </Col>
      {other && (
        <Col
          className="p-0 d-flex justify-content-end"
          style={{ marginInlineStart: 24 }}
        >
          {other}
        </Col>
      )}
      {dropdown && (
        <Col
          className={`p-0 d-flex justify-content-end text-nowrap ${
            notMain ? "" : "col-auto"
          }`}
        >
          <SvgPCMenuArrow notMain={notMain} rotate={rotate} />
        </Col>
      )}
    </Row>
  );
};

export default PCMenuItemTitle;
